/* eslint-disable prettier/prettier */
import { auth } from '../api/ApiUrl';
import { storeArq } from 'correos-arq-utils';

var createHistory = require('history').createBrowserHistory; // función para cerrar sesion: borrar la cookie de la persitencia del storeArq y cierra sesión en el ISAM


var Logout = function Logout(logoutSys) {
  try {
    // Poner la varible por defecto del opcional
    var logoutSysAux = true;

    if (logoutSys) {
      logoutSysAux = logoutSys;
    } // Cargar los datos del Store


    storeArq.load();

    if (storeArq.data.tipo_integracion === 'INTERN') {
      if (logoutSysAux) {
        storeArq.data.auth.logoutSys = logoutSysAux;
        storeArq.save();
        var history = createHistory({
          forceRefresh: true
        });
        history.push('/login');
      } else {
        storeArq["delete"](); // @ts-ignore

        var url = auth.logoutISAM;
        window.location.href = url;
      }
    } else {
      storeArq["delete"](); // @ts-ignore

      var _url = auth.logoutC_ID + '/' + window._env_.REACT_APP_CLIENT_ID_C_ID;

      window.location.href = _url;
    }
  } catch (error) {
    console.error('error.logout: ', error);
  }
};

export default Logout;